module.exports = __webpack_public_path__ + "static/media/logo.89f8f1a8.png";